import axios from 'axios';
import {
    CinemaZoneMoviesResponse,
    CheckoutRequest, CheckoutResponse,
    OrderResponse, PaypalCaptureOrderRequest, PaypalCaptureOrderResponse, PaypalCheckoutRequest,
    PaypalCheckoutResponse, ProductResponse, ShowsResponse, StripeCheckoutRequest,
    StripeCheckoutResponse
} from '../types/api';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';
const CINEMA_ZONE_API_BASE_URL = process.env.REACT_APP_CINEMA_ZONE_API_BASE_URL || 'https://cinemazone-api-uat.appvanz.au';

const api = axios.create({
  baseURL: API_BASE_URL,
});

const cinemaZoneApi = axios.create({
  baseURL: CINEMA_ZONE_API_BASE_URL,
});

export const getShows = async (): Promise<ShowsResponse> => {
  const response = await api.get<ShowsResponse>('/shows');
  return response.data;
};

export const getCinemaZoneMovies = async (): Promise<CinemaZoneMoviesResponse> => {
  const response = await cinemaZoneApi.get<CinemaZoneMoviesResponse>('/movies');
  return response.data;
};

export const getProduct = async (refId: string): Promise<ProductResponse> => {
  const response = await api.get<ProductResponse>(`/product/${refId}`);
  return response.data;
};

export const checkout = async (data: CheckoutRequest): Promise<CheckoutResponse> => {
  const response = await api.post<CheckoutResponse>('/checkout', data);
  return response.data;
};

export const getOrder = async (refId: string): Promise<OrderResponse> => {
    const response = await api.get<OrderResponse>(`/order/ref/${refId}`);
    return response.data;
};

export const stripeCheckout = async (data: StripeCheckoutRequest): Promise<StripeCheckoutResponse> => {
    const response = await api.post<StripeCheckoutResponse>('/stripe/create-checkout-session', data);
    return response.data;
};

export const paypalCheckout = async (data: PaypalCheckoutRequest): Promise<PaypalCheckoutResponse> => {
    const response = await api.post<PaypalCheckoutResponse>('/paypal/create-order', data);
    return response.data;
};

export const paypalCaptureOrder = async (data: PaypalCaptureOrderRequest): Promise<PaypalCaptureOrderResponse> => {
    const response = await api.post<PaypalCaptureOrderResponse>('/paypal/capture-order', data);
    return response.data;
};
